<template>
    <div class="container m-5 text-left">
        <b-row>
            <b-col>
                <p>
                    Разработано в <a href="https://actcognitive.org/">Национальном центре когнитивных разработок</a>
                </p>
                <p>
                    Если у вас есть предложения или вопросы по работе сервиса - напишите нам:
                </p>
                <ul>
                    <li>Автор идеи - Екатерина Ильина</li>
                    <li>Реализация - <a href="mailto:evsmirnov@itmo.ru">Смирнов Егор</a></li>
                </ul>
            </b-col>
        </b-row>
    </div>

</template>

<script>
    export default {
        name: "Contacts"
    }
</script>

<style scoped>

</style>